import React from "react"
import { ListOfSports } from "./ListOfSports"

const Sports = () => {
    return (
        <>
            <ListOfSports />
        </>
    )
}

export { Sports }